import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=17525f92&scoped=true&"
import script from "./roleManage.vue?vue&type=script&lang=js&"
export * from "./roleManage.vue?vue&type=script&lang=js&"
import style0 from "./roleManage.vue?vue&type=style&index=0&id=17525f92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17525f92",
  null
  
)

export default component.exports